// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {filterSearchResults} from '../../shared/services/product-search-helper';

export const resetProductSearchFacets = (allowedDealers, allowedStatuses) =>
    (dispatch, getState) => {

        const defaultSearchResults = getState().productSearch.searchResults;

        dispatch({
            allowedDealers,
            allowedStatuses,
            type: actions.RESET_PRODUCT_SEARCH_FACETS
        });

        dispatch({
            data: defaultSearchResults,
            type: actions.FILTER_PRODUCT_SEARCH_RESULTS
        });

    };

export const updateRegisteredDateRangeFacet = dateRange => ({
    dateRange,
    type: actions.UPDATE_REGISTERED_DATE_RANGE_FACET
});

export const selectAllDealersOnInitialLoad = allowedDealers =>
    dispatch => {

        dispatch({
            allowedDealers,
            type: actions.UPDATE_PRODUCT_SEARCH_DEALER_FACET_ON_LOAD
        });

        dispatch({
            allowedDealers,
            type: actions.UPDATE_REGISTRATION_FACET_ITEMS_ON_LOAD
        });

        dispatch({
            allowedDealers,
            type: actions.UPDATE_TRANSFER_APPROVAL_FACET_ITEMS_ON_LOAD
        });

        dispatch({
            allowedDealers,
            type: actions.UPDATE_TRANSFER_RECOMMENDATION_FACET_ITEMS_ON_LOAD
        });

    };

export const updateProductSearchDealerFacetInput = value => ({
    type: actions.UPDATE_PRODUCT_SEARCH_DEALER_FACET_INPUT,
    value
});

export const updateProductSearchDealerFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_PRODUCT_SEARCH_DEALER_FACET_ITEM
});

export const updateProductSearchDealerFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_PRODUCT_SEARCH_DEALER_FACET_ITEMS
});

export const updateProductSearchStatusFacetItem = (status, isSelected) => ({
    isSelected,
    status,
    type: actions.UPDATE_PRODUCT_SEARCH_STATUS_FACET_ITEM
});

export const updateProductSearchStatusFacetItems = allowedStatuses => ({
    allowedStatuses,
    type: actions.TOGGLE_PRODUCT_SEARCH_STATUS_FACET_ITEMS
});

export const applySearchFilters = () =>
    (dispatch, getState) => {

        const {productSearch} = getState();

        const selectedDealers = productSearch.facets.dealerAccountsFacet.selectedDealers;
        const selectedStatuses = productSearch.facets.statusFacet.selectedStatuses;
        const dateRange = productSearch.facets.registeredDateRange.dateRange;
        const currentSearchResults = productSearch.searchResults;

        dispatch({
            data: filterSearchResults(currentSearchResults, selectedDealers, selectedStatuses, dateRange),
            type: actions.FILTER_PRODUCT_SEARCH_RESULTS
        });

    };



// WEBPACK FOOTER //
// ./src/product/search/action-creators/facets.js